import { jsx as y } from "react/jsx-runtime";
import { c as t } from "./index-BNmRGtA6.js";
import { c as d } from "./clsx-OuTLNxxd.js";
import './Badge.css';const c = "_badge_1yk1u_1", m = "_primary_1yk1u_11", u = "_secondary_1yk1u_17", z = "_error_1yk1u_23", p = "_isRound_1yk1u_36", s = {
  badge: c,
  primary: m,
  secondary: u,
  error: z,
  "size-xs": "_size-xs_1yk1u_29",
  isRound: p,
  "size-s": "_size-s_1yk1u_41",
  "size-m": "_size-m_1yk1u_53",
  "size-l": "_size-l_1yk1u_67"
}, k = t(s.badge, {
  variants: {
    isRound: {
      true: s.isRound
    },
    size: {
      xs: s["size-xs"],
      s: s["size-s"],
      m: s["size-m"],
      l: s["size-l"]
    },
    variant: {
      primary: s.primary,
      secondary: s.secondary,
      error: s.error
    }
  },
  defaultVariants: {
    isRound: !1,
    size: "m",
    variant: "primary"
  }
}), b = ({
  children: r,
  className: a,
  isRound: e,
  size: i,
  style: o,
  variant: _,
  ...n
}) => /* @__PURE__ */ y(
  "span",
  {
    className: d(k({ isRound: e, size: i, variant: _ }), a),
    "data-cxy-name": "badge",
    style: o,
    ...n,
    children: r
  }
);
export {
  b as B
};
